export default __webpack_public_path__ + "static/media/cornering-65.e89cc8f6.svg";